import React from 'react';
import AttendeeLogin from './AttendeeLogin';
import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';
import { WEBLOGIN_V2_OFFSET_TOP_DEFAULT } from '../../constants/Enums';


const EmailLoginContainer = ({
    redirectUrl,
    isWidget,
}) => (
    <AttendeeLogin
        screen={LoginWidgetScreen.login}
        redirectUrl={redirectUrl}
        offsetTopOnEmbedded={isWidget ? WEBLOGIN_V2_OFFSET_TOP_DEFAULT : null}
        closable={false}
        isShownByDefault
    />
);

export default EmailLoginContainer;
